import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiJson } from "../../Api";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import Row from "react-bootstrap/Row";
import WebsiteFooter from "../../components/Footer/WebsiteFooter";
import pagesbannerimg from "../../assets/images/footer-page-images/offers-top-banner.jpg";
import ramadanimg1 from "../../assets/images/offers/Desktop-HOT-DEALS.jpg";
import ramadanimg2 from "../../assets/images/offers/center-img-desktop.jpg";
import ramadanimg3 from "../../assets/images/offers/right-img-desktop.jpg";
import WebsiteHeader from "../../components/header/WebsiteHeader";
import { set_loading } from "../../redux/actions/LayoutAction";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import "../../assets/styles/footer-pages/offers.scss";
import ProductList from "../../components/product/OffersVariantList";
import Countdown from "react-countdown";

import $ from "jquery";
import OffersMain from "../../components/customer/AllItems/OffersMain";
import VariantsModal from "../../components/customer/VariantsModal";

const OffersSections = (props) => {
  const [offers_sections, setOffersSections] = useState([]);
  const [top_banner, setTopBanner] = useState();
  const [boxes_banners, setBoxesBanners] = useState([]);
  const { t } = useTranslation();
  const [variantsModalShow, setVariantsModalShow] = React.useState(false);
  const [selectedProduct, setSelectedProduct] = React.useState(null);
  const [selectedSku, setSelectedSku] = React.useState(null);

  let message = "";
  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  let sections = [];

  useEffect(() => {
    document.title = "coffeesuq.com - Offers";
  }, []);

  useEffect(() => {
    apiJson.offers.getTopBanner(props.countryId).then(async (response) => {
      if (response.success) {
        setTopBanner(response.data);
      }
    });

    apiJson.offers.getBoxesBanners(props.countryId).then(async (response) => {
      if (response.success) {
        setBoxesBanners(response.data);
      }
    });

    apiJson.offers.offers_sections(props.countryId)
      .then(response => {
        if (response.success) {
          setOffersSections(response.data.sections);
        }
      });
  }, []);

  const onQuickViewClicked = (product, sku) => {
    setVariantsModalShow(true);
    setSelectedSku(sku);

    apiJson.
      singleItem.getItemData(product.id, product.product_type ? "products" : "services", props.countryId)
      .then(response => {
        response.data.type = "Product";

        setSelectedProduct(response.data);
      });
  }

  return (
    <Fragment>
      <div className="product-home-page-desktop mx-auto">
        <VariantsModal
          show={variantsModalShow}
          onHide={() => setVariantsModalShow(false)}
          closeModal={() => setVariantsModalShow(false)}
          product={selectedProduct}
          selected_sku={selectedSku}
        />
        <WebsiteHeader />

        <div className="content-wrapper all-page-container">
          <div className="offers-row">
            <div className="kid-fashion-banner-container">
              <a href="#">

                <div className="pagesbanner">
                  <img
                    src={top_banner?.website_image}
                    alt="category"
                    style={{
                      width: "100%",

                    }}
                  ></img>
                </div>

              </a>
            </div>
          </div>
          {
            boxes_banners.length > 0 ?
              <div className="row offerrow">
                {
                  boxes_banners.map((banner, key) => {
                    if (key < 3) {
                      return (
                        <div className="col-lg-4 col-md-4 col-sm-4 col-4">
                          <a href={banner.link}>
                            <img className="img-fluid"
                              src={banner.website_image}
                              alt="category"
                              style={{
                                width: "100%",
                              }}
                            ></img></a>
                        </div>
                      )
                    }
                  })
                }
              </div>
              :
              <></>
            // <div className="row offerrow">

            //   <div className="col-lg-4 col-md-4 col-sm-4 col-4">
            //     <a href="offers/section/hot-deals">
            //       <img className="img-fluid"
            //         src={ramadanimg1}
            //         alt="category"
            //         style={{
            //           width: "100%",
            //         }}
            //       ></img></a>
            //   </div>

            //   <div className="col-lg-4 col-md-4 col-sm-4 col-4">
            //     <a href="offers/section/buy-1-get-1">

            //       <img className="img-fluid"
            //         src={ramadanimg2}
            //         alt="category"
            //         style={{
            //           width: "100%",
            //         }}
            //       ></img>
            //     </a>
            //   </div>
            //   <div className="col-lg-4 col-md-4 col-sm-4 col-4">
            //     <a href="offers/section/summer-specials">

            //       <img className="img-fluid"
            //         src={ramadanimg3}
            //         alt="category"
            //         style={{
            //           width: "100%",
            //         }}
            //       ></img>
            //     </a>
            //   </div>
            // </div>
          }
          {
            offers_sections.map(section => {
              return (
                <Row
                  key={0}
                  className={`product-list-row mx-auto p-0`}
                >
                  <div className="title-row">
                    <div className={props.language == "en" ? "title" : "title text-right"}
                      dangerouslySetInnerHTML={{
                        __html: section.title_en,
                      }}
                    ></div>
                    <div class={props.language == "en" ? "viewalldiv" : "viewalldiv viewalldiv-ar"}>
                      <Link
                        to={
                          "/" + props.countryUrl + "-" + props.language + "/offers/section/" + section.url
                        }
                        className="view-all-text">
                        {t("all-categories.view-all")}
                      </Link>
                    </div>
                  </div>
                  <ProductList
                    type="product"
                    home={true}
                    products={section.offers_section_variants}
                    onQuickViewClicked={onQuickViewClicked}
                  />
                  <div />
                </Row>
              )
            })
          }
        </div>

        <WebsiteFooter />

      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    countryUrl: state.language.countryUrl,
    countryId: state.language.countryId,
    language: state.language.language,
  };
};

const mapDispatchToProps = {
  set_loading,
};

export default connect(mapStateToProps, mapDispatchToProps)(OffersSections);
